import moment from "moment";
import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { useAppDispatch, useAppSelector } from "../../config/hooks";
import { getTimesheetApi } from "../../slices/attendanceSlice";
import { useParams } from "react-router-dom";
import ExcelJS from "exceljs";
import ExDropdown from "../../components/basic-components/ExDropdown";
import { getHolidayListApi } from "../../slices/appSlice";
import { getMemberByIdApi } from "../../slices/companyMemberSlice";
import useEmployeeTimesheet from "../../utils/custome-hooks/useEmployeeTimesheet";

const monthList = [
  {
    Title: "Janaury",
    Id: 1,
    key: "01",
  },
  {
    Title: "February",
    Id: 2,
    key: "02",
  },
  {
    Title: "March",
    Id: 3,
    key: "03",
  },
  {
    Title: "April",
    Id: 4,
    key: "04",
  },
  {
    Title: "May",
    Id: 5,
    key: "05",
  },
  {
    Title: "June",
    Id: 6,
    key: "06",
  },
];
const EmployeeTimesheetHrView = () => {
  const dispatch = useAppDispatch();
  const { employeeId } = useParams();

  const userId = useAppSelector((state) => state.login.session.userId);
  const timesheet = useAppSelector((state) => state.attendance.timesheet);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const { getHoliday, employeeWorking } = useEmployeeTimesheet();

  function getDaysInMonth(year, month) {
    return new Date(year, month, 0).getDate();
  }

  useEffect(() => {
    dispatch(
      getMemberByIdApi({
        memberId: employeeId,
      })
    ).then((result) => {
      dispatch(getHolidayListApi(result?.payload?.data?.data?.workLocation));
    });
  }, []);

  function getDatesInRange(startDate, endDate) {
    const start = moment(startDate);
    const end = moment(endDate);
    const dates = [];

    while (start <= end) {
      dates.push(start.format("YYYY/MM/DD"));
      start.add(1, "days");
    }
    return dates;
  }

  let month =
    moment().month() > 8 ? moment().month() + 1 : 0 + moment().month() + 1;
  let year = moment().year();

  let days = getDatesInRange(
    moment(`${month}/01/${year}`).format("YYYY-MM-DD"),
    moment().format("YYYY-MM-DD")
  );

  const [allDates, setAllDates] = useState(days);

  useEffect(() => {
    let month =
      moment().month() > 8 ? moment().month() + 1 : 0 + moment().month() + 1;
    let year = moment().year();
    if (selectedMonth) {
      let days = getDaysInMonth(year, selectedMonth?.Id);
      dispatch(
        getTimesheetApi({
          dateFrom: moment(`${parseInt(selectedMonth.key)}/01/${year}`).format(
            "YYYY-MM-DD"
          ),
          dateTo: moment(
            `${parseInt(selectedMonth.key)}/${days}/${year}`
          ).format("YYYY-MM-DD"),
          employeeId: employeeId,
        })
      );
    } else {
      dispatch(
        getTimesheetApi({
          dateFrom: moment(`${month}/01/${year}`).format("YYYY-MM-DD"),
          dateTo: moment().format("YYYY-MM-DD"),
          employeeId: employeeId,
        })
      );
    }
  }, [selectedMonth]);

  const exportToExcel = async () => {
    // Create a new workbook with ExcelJS
    const workbook = new ExcelJS.Workbook();

    // Add a worksheet
    const worksheet = workbook.addWorksheet("Sheet1");

    worksheet.columns = [
      { header: "Day", key: "date", width: 20 },
      { header: "Date", key: "date", width: 20 },
      { header: "CheckIn", key: "checkIn", width: 20 },
      { header: "CheckOut", key: "checkOut", width: 20 },
      { header: "Working Hours", key: "workingHours", width: 20 },
      { header: "Task", key: "dailyReport", width: 20 },
    ];

    // Apply bold to the header row
    worksheet.getRow(1).font = { bold: true, size: 12 };

    allDates.forEach((item) => {
      if (employeeWorking(item)) {
        console.log(employeeWorking(item));
        var startTime = moment(employeeWorking(item).checkIn);
        var endTime = moment(employeeWorking(item).checkOut);
        var dif = moment.duration(endTime.diff(startTime));
        let isHalfDay = dif.hours() + parseFloat(`0.${dif.minutes()}`) < 8.3;
        const htmlContent = employeeWorking(item).dailyReport?.dailyReport[0];
        // Parse HTML content and get the text
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, "text/html");
        const text = doc.body.textContent || doc.body.innerText;
        const customizedData = [
          moment(employeeWorking(item).date).format("dddd"), // Example: Capitalize name
          moment(employeeWorking(item).date).format("DD/MM/YYYY"), // Example: Capitalize name
          moment(employeeWorking(item).checkIn).format("HH:mm"), // No change, just add as is
          moment(employeeWorking(item).checkOut).format("HH:mm"), // Example: Double the hours worked
          employeeWorking(item)?.status
            ? `${dif.hours()}:${
                dif.minutes() < 10 ? "0" + dif.minutes() : dif.minutes()
              }`
            : "",
          text,
        ];
        const row = worksheet.addRow(customizedData);
        const bgColor =
          moment(employeeWorking(item).date).format("dddd") === "Sunday" ||
          moment(employeeWorking(item).date).format("dddd") === "Saturday" ||
          getHoliday(item)
            ? "AA6C7275"
            : isHalfDay
            ? "AAF7FA0D"
            : "";

        row.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bgColor },
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      } else {
        console.log("Holiday or Leave", getHoliday(item));
        const customizedData = [
          moment(item).format("dddd"),
          moment(item).format("DD/MM/YYYY"),
          "",
          "Holiday",
          "",
          getHoliday(item)?.Ocassion,
        ];
        const row = worksheet.addRow(customizedData);
        const bgColor =
          moment(item).format("dddd") === "Sunday" ||
          moment(item).format("dddd") === "Saturday"
            ? "FF4CBB17"
            : getHoliday(item)
            ? "FF338CFF"
            : "FFFFA500";

        row.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bgColor },
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
      }
    });

    // Apply borders to all cells in the worksheet
    worksheet.eachRow({ includeEmpty: true }, function (row, rowNumber) {
      row.eachCell({ includeEmpty: true }, function (cell, colNumber) {
        // cell.border = {
        //   top: { style: 'thin' },
        //   left: { style: 'thin' },
        //   bottom: { style: 'thin' },
        //   right: { style: 'thin' },
        // };
        cell.alignment = { horizontal: "left" };
      });
    });

    // Save the file as a blob and download it
    workbook.xlsx.writeBuffer().then((buffer) => {
      const data = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(data);
      link.download = `${timesheet[0].employee.firstName}_${timesheet[0].employee.lastName}_Timesheet.xlsx`;
      link.click();
    });
  };

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    let days = getDaysInMonth(year, value?.Id);
    let allDays = getDatesInRange(
      moment(`${parseInt(value.key)}/01/${year}`).format("YYYY-MM-DD"),
      moment(`${parseInt(value.key)}/${days}/${year}`).format("YYYY-MM-DD")
    );
    setAllDates(allDays);
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="w-5/12">
          <h1 className="font-medium text-xl">
            Timesheet Of {timesheet && timesheet[0]?.employee?.firstName}{" "}
            {timesheet && timesheet[0]?.employee?.lastName}
          </h1>
        </div>
        <div className="flex items-center w-5/12">
          <div className="w-10/12">
            <ExDropdown
              title="" //this is used attribute for designatiion
              placeholder="Select"
              onChange={(value) => handleMonthChange(value)}
              value={selectedMonth}
              optionValue="Id"
              optionLabel="Title"
              options={monthList}
              dropDownHeight="40px"
              dropDownBorderWidth="1px"
              dropDownBorderColor="#8C8C8C"
              error={undefined}
              isMandatory={false}
            />
          </div>
          <button
            onClick={() => exportToExcel()}
            className="bg-secondary-700 text-exwhite-100 py-1 px-5 rounded-md ml-4 border border-primary-500"
          >
            Export
          </button>
        </div>
      </div>
      <div>
        <table className="w-full mt-4 rounded-sm border border-exgray-100">
          <thead className="py-3 bg-secondary-800">
            <tr className="border border-exgray-100">
              <th className="text-sm text-exwhite-100 font-medium py-3 px-2 w-1/12 text-start">
                Date
              </th>
              <th className="text-sm text-exwhite-100 font-medium py-3 px-2 w-1/12 text-start">
                Day
              </th>
              <th className="text-sm text-exwhite-100 font-medium py-3 px-2 w-1.5/12 text-start">
                Start-Time
              </th>
              <th className="text-sm text-exwhite-100 font-medium py-3 px-2 w-1.5/12 text-start">
                End-Time
              </th>
              <th className="text-sm text-exwhite-100 font-medium py-3 px-2 w-2/12 text-center">
                Working Hrs
              </th>
              <th className="text-sm text-exwhite-100 font-medium py-3 px-2 w-5/12 text-start">
                Task List
              </th>
            </tr>
          </thead>
          {/* <tbody className="items-center justify-center ">
            {
              timesheet?.map((t) => {
                var startTime = moment(t.checkIn);
                var endTime = moment(t.checkOut);
                var dif = moment.duration(endTime.diff(startTime));
                return (
                  <tr className="items-center bg-exwhite-100 border-b-2 border-bg-primary-100/50">
                    <td className="items-center py-3 px-2">
                      {moment(t.date).format('DD/MM/YYYY')}
                      <p className='text-xs text-exgray-200'>{moment(t.date).format('dddd')}</p>
                    </td>
                    <td className="px-2 text-start py-3 text-secondary-500 font-medium">
                      {moment(t.checkIn).format('LT')}
                    </td>
                    <td className="px-2 text-start py-3 text-secondary-500 font-medium">
                      {t?.status ? moment(t.checkOut).format('LT') : ''}
                    </td>
                    <td className="px-2 text-center py-3 text-secondary-500 font-medium">
                      {t?.status ? `${dif.hours()}:${dif.minutes() < 10 ? "0" + dif.minutes() : dif.minutes()}` : ''}
                    </td>
                    <td className="px-2 items-center">
                      <ReactQuill
                        style={{ paddingBottom: -15, marginBottom: -35 }}
                        value={t?.dailyReport?.dailyReport[0]}
                        readOnly={true}
                        theme={"bubble"}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody> */}
          <tbody className="items-center justify-center ">
            {allDates?.map((date) => {
              // var startTime = moment(t.checkIn);
              // var endTime = moment(t.checkOut);
              // var dif = moment.duration(endTime.diff(startTime));
              // if (employeeWorking(date)) {

              // }

              if (employeeWorking(date)) {
                var startTime = moment(employeeWorking(date).checkIn);
                var endTime = moment(employeeWorking(date).checkOut);
                var dif = moment.duration(endTime.diff(startTime));
                let isHalfDay =
                  dif.hours() + parseFloat(`0.${dif.minutes()}`) < 8.3;
                return (
                  <tr
                    className={`${
                      moment(date).format("dddd") == "Sunday" ||
                      moment(date).format("dddd") == "Saturday" ||
                      getHoliday(date)
                        ? "bg-exgray-200"
                        : isHalfDay
                        ? "bg-yellow-200"
                        : ""
                    } items-center border-b border-l border-r border-exgray-100`}
                  >
                    <td className="items-center py-1 px-2 text-sm">
                      {moment(date).format("DD/MM/YYYY")}
                    </td>
                    <td className="px-2 text-sm text-start py-1 text-secondary-500 font-medium text-nowrap">
                      {moment(date).format("dddd")}
                    </td>
                    <td className="px-2 text-sm text-start py-1 text-secondary-500 font-medium text-nowrap">
                      {moment(employeeWorking(date).checkIn).format("LT")}
                    </td>
                    <td className="px-2 text-sm text-start py-1 text-secondary-500 font-medium text-nowrap">
                      {moment(employeeWorking(date).checkOut).format("LT")}
                    </td>
                    <td className="px-2 text-sm text-center py-1 text-secondary-500 font-medium">
                      {employeeWorking(date)?.status
                        ? `${dif.hours()}:${
                            dif.minutes() < 10
                              ? "0" + dif.minutes()
                              : dif.minutes()
                          }`
                        : ""}
                    </td>
                    <td className="px-2 items-center">
                      <ReactQuill
                        // style={{ paddingBottom: -15, marginBottom: -35 }}
                        value={
                          employeeWorking(date)?.dailyReport?.dailyReport[0]
                        }
                        readOnly={true}
                        theme={"bubble"}
                      />
                    </td>
                  </tr>
                );
              } else if (getHoliday(date)) {
                return (
                  <tr
                    className={`bg-secondary-400 items-center border-b border-l border-r border-exgray-100`}
                  >
                    <td className="items-center text-sm py-1 px-2">
                      {moment(date).format("DD/MM/YYYY")}
                    </td>
                    <td className="px-2 text-sm text-start py-1 font-medium text-nowrap">
                      {moment(date).format("dddd")}
                    </td>
                    <td className="px-2 text-start py-1 text-secondary-500 font-medium text-nowrap"></td>
                    <td className="px-2 text-start py-1 text-secondary-500 font-medium text-nowrap"></td>
                    <td className="px-2 text-center py-1 text-secondary-500 font-medium"></td>
                    <td className="px-2 items-center">
                      {getHoliday(date).Ocassion}
                    </td>
                  </tr>
                );
              } else if (moment(date).isBefore(moment())) {
                return (
                  <tr
                    className={`${
                      moment(date).format("dddd") == "Sunday" ||
                      moment(date).format("dddd") == "Saturday"
                        ? "bg-green-200"
                        : "bg-orange-400"
                    } items-center border-b border-l border-r border-exgray-100 border-b-exgray-200`}
                  >
                    <td className="items-center text-sm py-1 px-2">
                      {moment(date).format("DD/MM/YYYY")}
                    </td>
                    <td className="px-2 text-sm text-start py-1 text-secondary-500 font-medium text-nowrap">
                      {moment(date).format("dddd")}
                    </td>
                    <td className="px-2 text-start py-1 text-secondary-500 font-medium text-nowrap"></td>
                    <td className="px-2 text-start py-1 text-secondary-500 font-medium text-nowrap"></td>
                    <td className="px-2 text-center py-1 text-secondary-500 font-medium"></td>
                    <td className="px-2 items-center font-bold text-base text-exwhite-100">
                      {moment(date).format("dddd") !== "Sunday" &&
                      moment(date).format("dddd") !== "Saturday"
                        ? "Leave"
                        : ""}
                    </td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default EmployeeTimesheetHrView;
